import Admin from "../Admin";
import CardAdminProviderGeneral from "../../../Component/Card/Admin/Provider/CardAdminProviderGeneral";
import CardAdminProviderContact from "../../../Component/Card/Admin/Provider/CardAdminProviderContact";
import CardAdminProviderCredentialing from "../../../Component/Card/Admin/Provider/CardAdminProviderCredentialing";
import CardAdminProviderExternalIdentifiers from "../../../Component/Card/Admin/Provider/CardAdminProviderExternalIdentifiers";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIDeleteIcon from "@mui/icons-material/Delete";
import MUISaveButton from "@mui/icons-material/Save";
import MUILoadingButton from "@mui/lab/LoadingButton";
import Menu from "../../../Component/Menu";
import DialogConfirm from "../../../Component/Dialog/DialogConfirm";
import MUIMenuItem from '@mui/material/MenuItem';
import MUIListItemIcon from '@mui/material/ListItemIcon';
import ProviderService from "../../../Seating/Security/ProviderService/providerService";

import Validator from "../../../Utility/Validator";

import { enqueueSnackbar as NotistackEnqueueSnackbar } from "notistack";

export default class ProviderCreateEdit extends Admin {
    constructor(props) {
        super(props);

        this.state.provider = null;
        this.state.isProcessing = false;
        this.state.isUpdate = !!props.match.params.id;
        this.state.confirmDialogOpen = false;
        this.state.validationIssues = {};
    }

    afterComponentDidMount() {
        const providerId = this.props.match.params.id ? +this.props.match.params.id : null;

        if (providerId !== null) {
            ProviderService.getProviderById(providerId)
                .then((provider) => {
                    this.setState({
                        provider: provider,
                    });
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }

    async createProvider() {
        this.setState({ isProcessing: true });

        return ProviderService.createProvider(this.state.provider)
            .then(provider => {
                this.context.updateIndexed("providersIndexed", provider);
                this.props.history.goBack();
                NotistackEnqueueSnackbar("Provider created successfully!", { variant: "success" });
            })
            .catch((err) => {
                console.log(err);
                NotistackEnqueueSnackbar("Error creating Provider.", { variant: "error" });
                this.setState({ isProcessing: false });
            });
    }

    async updateProvider() {
        this.setState({ isProcessing: true });

        return ProviderService.updateProvider(this.state.provider)
            .then(provider => {
                this.context.updateIndexed("providersIndexed", provider);
                this.props.history.goBack();
                NotistackEnqueueSnackbar("Provider updated successfully!", { variant: "success" });
            })
            .catch(err => {
                console.log(err);
                NotistackEnqueueSnackbar("Error updating Provider.", { variant: "error" });
                this.setState({ isProcessing: false });
            });
    }

    async deleteProvider() {
        this.setState({ isProcessing: true });

        return ProviderService.deleteProvider(this.state.provider.id)
            .then(() => {
                this.context.deleteIndexed("providersIndexed", this.state.provider.id);
                this.props.history.goBack();
                NotistackEnqueueSnackbar("Provider deleted successfully!", { variant: "success" });
            })
            .catch((err) => {
                console.log(err);
                NotistackEnqueueSnackbar("Error deleting Provider.", { variant: "error" });
                this.setState({ confirmDialogOpen: false });
            });
    }

    renderContent() {
        const handleChange = (provider) => {
            this.setState({
                provider: {
                    ...this.state.provider,
                    ...provider,
                },
            });
        };
 
        return (
            <>
                <CardAdminProviderGeneral
                    provider={this.state.provider}
                    onChange={handleChange.bind(this)}
                    validationIssues={this.state.validationIssues}
                />
                <CardAdminProviderContact
                    provider={this.state.provider}
                    onChange={handleChange.bind(this)}
                    validationIssues={this.state.validationIssues}
                />
                <CardAdminProviderCredentialing
                    provider={this.state.provider}
                    onChange={handleChange.bind(this)}
                    validationIssues={this.state.validationIssues}
                />
                <CardAdminProviderExternalIdentifiers
                    provider={this.state.provider}
                    onChange={handleChange.bind(this)}
                    validationIssues={this.state.validationIssues}
                />
                <DialogConfirm
                    open={this.state.confirmDialogOpen}
                    onClose={() => this.setState({ confirmDialogOpen: false })}
                    onConfirm={() => this.deleteProvider()}
                    text="Are you sure you want to delete this Provider? This cannot be undone."
                    header="Delete Provider"
                    loading={this.state.isProcessing}
                />
            </>
        );
    }

    renderHeader() {
        let title;
        const buttonText = this.state.isUpdate ? "Save" : "Create";

        if (!this.state.isUpdate) {
            title = 'Create Provider';
        } else {
            title = 'Edit Provider';
        }

        const handleClickBack = () => {
            this.props.history.goBack();
        };

        const handleClickSave = () => {
            const validationIssues = Validator.validate(
                this.state.provider,
                {
                    firstName: {
                        'required': true
                    },
                    lastName: {
                        'required': true
                    },
                    phoneNumber: {
                        'type': 'phone',
                    },
                    faxNumber: {
                        'type': 'phone',
                    },
                    npi: {
                        'required': true,
                        'type': 'npi',
                    },
                    brightreeExternalKey: {
                        'type': 'integer',
                    },
                    taxId: {
                        'type': 'integer',
                    },
                }
            );

            this.setState({ validationIssues });

            if (Object.keys(validationIssues).length === 0) {
                if (this.state.isUpdate) {
                    this.updateProvider();
                } else {
                    this.createProvider();
                }
            } else {
                NotistackEnqueueSnackbar("Please correct the displayed issues.", { variant: "error" });
            }
        };

        const handleDelete = () => {
            this.setState({ confirmDialogOpen: true });
        };

        const buttons = [
            (<MUIButton onClick={handleClickBack}>Back</MUIButton>),
            (
                <MUILoadingButton
                    loading={this.state.isProcessing}
                    loadingPosition="start"
                    onClick={handleClickSave}
                    variant="contained"
                    startIcon={<MUISaveButton />}>
                    {buttonText}
                </MUILoadingButton>
            )
        ];

        if (this.state.isUpdate) {
            const menuItems = [
                (
                    <MUIMenuItem onClick={handleDelete}>
                        <MUIListItemIcon>
                            <MUIDeleteIcon fontSize="small" />
                        </MUIListItemIcon>
                        Delete
                    </MUIMenuItem>
                )
            ];
            buttons.push((<Menu menuItems={menuItems} />));
        }

        return (
            <PageHeader title={title} buttons={buttons} />
        );
    }
}
